// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once patient editing uses an sp app.
import { settleMount } from "#ce/framework/mount-ready";

const RELATIONSHIP_SELECTOR = "[data-behaviour~=patient-contact-relationship-selector]";
const SELECTOR_CONTAINER = "[data-behaviour~=patient-relationship-selector-container]";
const FIELD_CONTAINER = "[data-behaviour~=patient-relationship-selector-field-container]";
const FIELD_CONTROLS = "input, select, textarea, button, sp-select, sp-date-field";

/**
 * Shows the facility or the person fields that match the chosen contact relationship, and
 * disables the controls of the hidden set. Ignores events from other controls and hidden forms.
 *
 * @param {Event} event
 */
function updateFacilityFields(event) {
  const control = event.target.closest?.(RELATIONSHIP_SELECTOR);

  if (!control) {
    return;
  }

  const isFacility = String(selectedIsFacility(control));
  const container = control.closest(SELECTOR_CONTAINER)?.querySelector(FIELD_CONTAINER);

  if (!container?.getClientRects().length) {
    return;
  }

  for (const fields of container.querySelectorAll("[data-is-facility-fields]")) {
    const visible = fields.dataset.isFacilityFields === isFacility;

    fields.style.display = visible ? "" : "none";

    for (const input of fields.querySelectorAll(FIELD_CONTROLS)) {
      input.disabled = !visible;
    }
  }
}

/**
 * Synchronizes visible contact fields with relationship selections within `root`, skipping failed control mounts and
 * selections that name no relationship.
 *
 * @param {ParentNode} root
 * @returns {Promise<void>}
 */
export async function initializePatientContactFacilityFields(root) {
  const controls = Array.from(root?.querySelectorAll(RELATIONSHIP_SELECTOR) || []);

  for (const control of controls) {
    if ((await settleMount(control)) && selectedIsFacility(control) !== undefined) {
      updateFacilityFields({ target: control });
    }
  }
}

function initializeDocumentFields() {
  initializePatientContactFacilityFields(document).catch(console.error);
}

function selectedIsFacility(control) {
  if (control instanceof HTMLSelectElement) {
    return control.selectedOptions[0]?.dataset.isFacility;
  }

  return control.items.find((item) => String(item.value) === String(control.value))?.dataset?.isFacility;
}

document.addEventListener("change", updateFacilityFields);
document.addEventListener("input", updateFacilityFields);

document.addEventListener("DOMContentLoaded", initializeDocumentFields);

if (document.readyState !== "loading") {
  initializeDocumentFields();
}
